import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { navGroups, serviceLinks } from '../../data/navigation';
import { ArrowButton } from '../ui/ArrowButton';
type MobileMenuProps = {
  open: boolean;
};
export function MobileMenu({
  open
}: MobileMenuProps) {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <AnimatePresence data-id="element-228" data-mp="1e9hsrn6suylw">
      {open && <motion.nav aria-label="Menu mobile" initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="absolute inset-x-0 top-full max-h-[calc(100vh-76px)] overflow-y-auto border-b border-line bg-white px-6 pb-8 lg:hidden" data-id="element-229" data-mp="19czn8l3naw8i">
          <ul className="divide-y divide-line" data-id="element-230" data-mp="qmi2b2p214xp">
            <li data-id="element-231" data-mp="qlq4rmbwcx4s">
              <Link to="/" className="block py-4 text-lg font-medium" data-id="element-232" data-mp="qk5jknbh2qjl">
                Accueil
              </Link>
            </li>
            {navGroups.map(group => {
          const isOpen = expanded === group.label;
          return <li key={group.label} data-id="element-233" data-mp="9x7x5vkcwvep">
                  <button type="button" aria-expanded={isOpen} onClick={() => setExpanded(isOpen ? null : group.label)} className="flex w-full items-center justify-between py-4 text-lg font-medium" data-id="element-234" data-mp="9yix1kaolj0j">
                    {group.label}
                    <ChevronDownIcon className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-235" data-mp="3md1yqdwalgbs" />
                  </button>
                  {isOpen && <ul className="pb-4" data-id="element-236" data-mp="11pp12btiw0v3">
                      {group.links.map(link => <li key={link.path} data-id="element-237" data-mp="16oide0x2plto">
                          <Link to={link.path} className="block py-2 pl-3 text-[15px] text-ink-muted" data-id="element-238" data-mp="32oslxtgtipce">
                            {link.label}
                          </Link>
                        </li>)}
                    </ul>}
                </li>;
        })}
          </ul>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-[14px] text-ink-muted" data-id="element-239" data-mp="37pgb09lhkw3z">
            {serviceLinks.map(link => <Link key={link.path} to={link.path} data-id="element-240" data-mp="2ezzk5gdiln9v">
                {link.label}
              </Link>)}
          </div>
          <ArrowButton to="/acces-comptes" className="mt-6" data-id="element-241" data-mp="2tpxg4ihorh9m">
            Accès à vos comptes
          </ArrowButton>
        </motion.nav>}
    </AnimatePresence>;
}